import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  addPropertyBtn: {
    color: theme.indigo1
  }
}));
